import { createConfig } from '@streaming/mouflon-utils';
import { IPlayerCommonConfig } from 'types/common';

export interface IStreamConfig {
  HLSStreamUrl?: string;
  WebRTCSignallingServerUrl?: string;
  WebRTCStreamId?: string;
}

export const defaultMouflonPlayerConfig: IPlayerCommonConfig = {
  videoControllerConfig: {
    autoplay: false,
    isRemote: true,
  },
  hlsConfig: {},
  webRTCConfig: {},
  nativeConfig: {},

  minUpscaleFactor: 0,
  persistent: false,
  establishWSOnStart: false,

  reportModifiedMSE: false,
  forbidModifiedMSE: false,
  isShouldWatchDogStopStream: false,
};

export const { setConfig, ConfigConsumer } = createConfig<IPlayerCommonConfig>(
  defaultMouflonPlayerConfig,
);
